/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const HubAnnotationOrigin = {
    EXTERNAL: "EXTERNAL",
    MANUAL: "MANUAL",
    MODEL: "MODEL",
};
export const HubAnnotationSourceKind = {
    USER: "USER",
    JOB: "JOB",
    UNKNOWN: "UNKNOWN",
    CUSTOM: "CUSTOM",
};
export const HubAnnotationStatus = {
    COMPLETE: "COMPLETE",
    PARTIAL: "PARTIAL",
    NONE: "NONE",
};
export const HubArrayDataType = {
    Bool: "Bool",
    I8: "I8",
    I16: "I16",
    I32: "I32",
    I64: "I64",
    U8: "U8",
    U16: "U16",
    U32: "U32",
    U64: "U64",
    F16: "F16",
    F32: "F32",
    F64: "F64",
};
export const HubAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
};
export const HubBrandingItemId = {
    Logo: "logo",
    Favicon: "favicon",
    PrimaryColor: "primaryColor",
    CookiePolicy: "cookiePolicy",
    PrivacyPolicy: "privacyPolicy",
    TermsAndConditions: "termsAndConditions",
    OnScreenText: "onScreenText",
    DocumentationUrl: "documentationUrl",
};
export const HubBrandingType = {
    Color: "color",
    File: "file",
    Url: "url",
};
export const HubBuildState = {
    CHECKING_COMPATIBILITY: "CHECKING_COMPATIBILITY",
    PENDING: "PENDING",
    READY: "READY",
    FAILED: "FAILED",
    DELETING: "DELETING",
    DELETED: "DELETED",
};
export const HubCameraActivity = {
    IDLE: "IDLE",
    IN_USE: "IN_USE",
    RECORDING: "RECORDING",
    INVALID: "INVALID",
    VALIDATING: "VALIDATING",
    INFERENCE: "INFERENCE",
    GRABBING_THUMBNAIL: "GRABBING_THUMBNAIL",
};
export const HubCameraType = {
    BASLER: "BASLER",
    ALLIED_VISION: "ALLIED_VISION",
};
export const HubDatapointFieldSourceType = {
    Dataset: "Dataset",
};
export const HubDatapointFieldType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Class: "Class",
    Datetime: "Datetime",
    UUID: "UUID",
    SampleIDs: "Sample IDs",
};
export const HubDefaultExamplePickingStrategy = {
    LATEST: "LATEST",
    RANDOM: "RANDOM",
    SELECTION: "SELECTION",
    SINGLESOURCE: "SINGLESOURCE",
};
export const HubDeploymentStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
    FAILED: "FAILED",
};
export const HubExamplePickingStrategy = {
    RANDOM: "RANDOM",
    LATEST: "LATEST",
};
export const HubFileEncoding = {
    Plain: "plain",
    Base64: "base64",
};
export const HubImageMode = {
    LU8: "L_U8",
    LF32: "L_F32",
    LF64: "L_F64",
    LAU8: "LA_U8",
    LAF32: "LA_F32",
    LAF64: "LA_F64",
    RGBU8: "RGB_U8",
    RGBF32: "RGB_F32",
    RGBF64: "RGB_F64",
    RGBAU8: "RGBA_U8",
    RGBAF32: "RGBA_F32",
    RGBAF64: "RGBA_F64",
    BGRU8: "BGR_U8",
    BGRF32: "BGR_F32",
    BGRF64: "BGR_F64",
    BGRAU8: "BGRA_U8",
    BGRAF32: "BGRA_F32",
    BGRAF64: "BGRA_F64",
    YCbCrU8: "YCbCr_U8",
    BayerRGU8: "BayerRG_U8",
    BayerRGU10: "BayerRG_U10",
    BayerRGU12: "BayerRG_U12",
    JPEG: "JPEG",
    PNG: "PNG",
    GIF: "GIF",
    BMP: "BMP",
};
export const HubInferenceBundleSource = {
    Test: "test",
    Deployment: "deployment",
};
export const HubJobKind = {
    ModelTraining: "modelTraining",
    ModelFinetuning: "modelFinetuning",
    AnnotationPrediction: "annotationPrediction",
    AnnotationComparison: "annotationComparison",
    CameraCalibration: "cameraCalibration",
    Recording: "recording",
    Custom: "custom",
};
export const HubJobStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    DONE: "DONE",
    FAILED: "FAILED",
    STOPPING: "STOPPING",
    STOPPED: "STOPPED",
};
export const HubLogLevel = {
    SYSTEM_STATUS: "SYSTEM_STATUS",
    DEBUG: "DEBUG",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR",
};
export const HubMetricWidget = {
    Scalar: "Scalar",
    Line: "Line",
    ConfusionMatrix: "Confusion Matrix",
    Bar: "Bar",
    Histogram: "Histogram",
    ROC: "ROC",
    ScoreGraph: "Score Graph",
    Percentage: "Percentage",
};
export const HubPixelDataLayout = {
    HeightWidthChannels: "HeightWidthChannels",
    ChannelsHeightWidth: "ChannelsHeightWidth",
};
export const HubResourceKind = {
    PARAMETERS: "PARAMETERS",
    EXAMPLES: "EXAMPLES",
    DATASET: "DATASET",
    DATAPOOL: "DATAPOOL",
    MODEL: "MODEL",
    BLOB: "BLOB",
};
export const HubSplitStrategy = {
    RANDOM: "RANDOM",
    STRATIFIED: "STRATIFIED",
};
export const HubWorkflowStatus = {
    QUEUED: "QUEUED",
    STARTING: "STARTING",
    RUNNING: "RUNNING",
    STOPPING: "STOPPING",
    DELETING: "DELETING",
    STOPPED: "STOPPED",
    DONE: "DONE",
    FAILED: "FAILED",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "/hub/api/v1",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Hub
 * @version 0.1.0
 * @baseUrl /hub/api/v1
 */
export class Api extends HttpClient {
    algorithms = {
        /**
         * @description List algorithms. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithms
         * @summary List Algorithms
         * @request GET:/algorithms
         * @secure
         */
        listAlgorithms: (query, params = {}) => this.request({
            path: `/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmFields
         * @summary List Algorithm Fields
         * @request GET:/algorithms/fields
         * @secure
         */
        listAlgorithmFields: (params = {}) => this.request({
            path: `/algorithms/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a new algorithm by uploading thumbnail and algorithm spec. The algorithm image should be prebuilt and pushed to the docker registry. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name CreateNewAlgorithmPrebuilt
         * @summary Create New Algorithm Prebuilt
         * @request POST:/algorithms/prebuilt
         * @secure
         */
        createNewAlgorithmPrebuilt: (data, query, params = {}) => this.request({
            path: `/algorithms/prebuilt`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithms registry details. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmsRegistry
         * @summary Get Algorithms Registry
         * @request GET:/algorithms/registry
         * @secure
         */
        getAlgorithmsRegistry: (params = {}) => this.request({
            path: `/algorithms/registry`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List algorithm types. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name ListAlgorithmTypes
         * @summary List Algorithm Types
         * @request GET:/algorithms/types
         * @secure
         */
        listAlgorithmTypes: (params = {}) => this.request({
            path: `/algorithms/types`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmTypes
         * @summary Get Algorithm Types
         * @request GET:/algorithms/types/{algorithm_type}
         * @secure
         */
        getAlgorithmTypes: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm type thumbnail. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmTypeThumbnail
         * @summary Get Algorithm Type Thumbnail
         * @request GET:/algorithms/types/{algorithm_type}/thumbnail
         * @secure
         */
        getAlgorithmTypeThumbnail: (algorithmType, params = {}) => this.request({
            path: `/algorithms/types/${algorithmType}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
        /**
         * @description List daemons for algorithm. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListAlgorithmDaemons
         * @summary List Algorithm Daemons
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons
         * @secure
         */
        listAlgorithmDaemons: (algorithmId, algorithmVersion, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a daemon. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name GetDaemon
         * @summary Get Daemon
         * @request GET:/algorithms/{algorithm_id}/{algorithm_version}/daemons/{definition_id}
         * @secure
         */
        getDaemon: (algorithmId, algorithmVersion, definitionId, params = {}) => this.request({
            path: `/algorithms/${algorithmId}/${algorithmVersion}/daemons/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete an algorithm. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name DeleteAlgorithm
         * @summary Delete Algorithm
         * @request DELETE:/algorithms/{id}/{version}
         * @secure
         */
        deleteAlgorithm: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "DELETE",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithm
         * @summary Get Algorithm
         * @request GET:/algorithms/{id}/{version}
         * @secure
         */
        getAlgorithm: (id, version, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update Algorithm build state. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name UpdateAlgorithmBuildState
         * @summary Update Algorithm Build State
         * @request PATCH:/algorithms/{id}/{version}
         * @secure
         */
        updateAlgorithmBuildState: (id, version, data, params = {}) => this.request({
            path: `/algorithms/${id}/${version}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm definition. If the original flag is set to True, the definition will be returned in the same schema version as it was created by the originating algorithm. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmDefinition
         * @summary Get Algorithm Definition
         * @request GET:/algorithms/{id}/{version}/definition
         * @secure
         */
        getAlgorithmDefinition: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/definition`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm docker image url. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmImageUrl
         * @summary Get Algorithm Image Url
         * @request GET:/algorithms/{id}/{version}/image-url
         * @secure
         */
        getAlgorithmImageUrl: (id, version, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/image-url`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get algorithm thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags algorithms
         * @name GetAlgorithmThumbnail
         * @summary Get Algorithm Thumbnail
         * @request GET:/algorithms/{id}/{version}/thumbnail
         * @secure
         */
        getAlgorithmThumbnail: (id, version, query, params = {}) => this.request({
            path: `/algorithms/${id}/${version}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    alpha = {
        /**
         * @description Retrieve calibration resources for the specified camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags alpha, cameras
         * @name ListCameraCalibrationResources
         * @summary List Camera Calibration Resources
         * @request GET:/alpha/cameras/{camera_id}/calibration-resources
         * @secure
         */
        listCameraCalibrationResources: (cameraId, query, params = {}) => this.request({
            path: `/alpha/cameras/${cameraId}/calibration-resources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    branding = {
        /**
         * @description Full reset to defaults for the entire branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ResetToDefaults
         * @summary Reset To Defaults
         * @request DELETE:/branding
         * @secure
         */
        resetToDefaults: (params = {}) => this.request({
            path: `/branding`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name UpdateBranding
         * @summary Update Branding
         * @request PUT:/branding
         * @secure
         */
        updateBranding: (data, params = {}) => this.request({
            path: `/branding`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns a list of all the branding items **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name GetBrandingFields
         * @summary Get Branding Fields
         * @request GET:/branding/fields
         * @secure
         */
        getBrandingFields: (params = {}) => this.request({
            path: `/branding/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Import a branding configuration from a JSON file. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name ImportBrandingConfig
         * @summary Import Branding Config
         * @request POST:/branding/import
         * @secure
         */
        importBrandingConfig: (data, query, params = {}) => this.request({
            path: `/branding/import`,
            method: "POST",
            query: query,
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Bulk update the branding configuration. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags branding
         * @name BulkUpdateBranding
         * @summary Bulk Update Branding
         * @request PUT:/branding/json
         * @secure
         */
        bulkUpdateBranding: (data, query, params = {}) => this.request({
            path: `/branding/json`,
            method: "PUT",
            query: query,
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Returns all the overridden branding items. If an item is None, the default (robovision) branding should be shown.
         *
         * @tags branding
         * @name GetPublicBranding
         * @summary Get Public Branding
         * @request GET:/branding/public
         * @secure
         */
        getPublicBranding: (params = {}) => this.request({
            path: `/branding/public`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    cameras = {
        /**
         * @description List all cameras. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name ListCameras
         * @summary List Cameras
         * @request GET:/cameras
         * @secure
         */
        listCameras: (query, params = {}) => this.request({
            path: `/cameras`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name AddCamera
         * @summary Add Camera
         * @request POST:/cameras
         * @secure
         */
        addCamera: (data, params = {}) => this.request({
            path: `/cameras`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name DeleteCamera
         * @summary Delete Camera
         * @request DELETE:/cameras/{camera_id}
         * @secure
         */
        deleteCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCamera
         * @summary Get Camera
         * @request GET:/cameras/{camera_id}
         * @secure
         */
        getCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCamera
         * @summary Update Camera
         * @request PATCH:/cameras/{camera_id}
         * @secure
         */
        updateCamera: (cameraId, data, params = {}) => this.request({
            path: `/cameras/${cameraId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Update camera activity. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name UpdateCameraActivity
         * @summary Update Camera Activity
         * @request PATCH:/cameras/{camera_id}/activity
         * @secure
         */
        updateCameraActivity: (cameraId, data, params = {}) => this.request({
            path: `/cameras/${cameraId}/activity`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera config. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraConfig
         * @summary Get Camera Config
         * @request GET:/cameras/{camera_id}/config
         * @secure
         */
        getCameraConfig: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/config`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description Grab an image from a camera and set it as a thumbnail. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GrabThumbnail
         * @summary Grab Thumbnail
         * @request POST:/cameras/{camera_id}/grab-thumbnail
         * @secure
         */
        grabThumbnail: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/grab-thumbnail`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraThumbnail
         * @summary Get Camera Thumbnail
         * @request GET:/cameras/{camera_id}/thumbnail
         * @secure
         */
        getCameraThumbnail: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/thumbnail`,
            method: "GET",
            secure: true,
            format: "blob",
            ...params,
        }),
        /**
         * @description Validate a camera. This validates if the camera is currently reachable and if the config file is valid for the camera. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name ValidateCamera
         * @summary Validate Camera
         * @request POST:/cameras/{camera_id}/validate
         * @secure
         */
        validateCamera: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/validate`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get camera validation logs. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name GetCameraValidationLogs
         * @summary Get Camera Validation Logs
         * @request GET:/cameras/{camera_id}/validation-logs
         * @secure
         */
        getCameraValidationLogs: (cameraId, params = {}) => this.request({
            path: `/cameras/${cameraId}/validation-logs`,
            method: "GET",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags cameras
         * @name AddValidationLogs
         * @summary Add Validation Logs
         * @request PUT:/cameras/{camera_id}/validation-logs
         * @secure
         */
        addValidationLogs: (cameraId, data, params = {}) => this.request({
            path: `/cameras/${cameraId}/validation-logs`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    classes = {
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClasses
         * @summary Delete Classes
         * @request DELETE:/classes
         * @secure
         */
        deleteClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "DELETE",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classess. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClasses
         * @summary List Classes
         * @request GET:/classes
         * @secure
         */
        listClasses: (query, params = {}) => this.request({
            path: `/classes`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create classes. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name CreateClasses
         * @summary Create Classes
         * @request POST:/classes
         * @secure
         */
        createClasses: (data, params = {}) => this.request({
            path: `/classes`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List classes fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name ListClassesFields
         * @summary List Classes Fields
         * @request GET:/classes/fields
         * @secure
         */
        listClassesFields: (params = {}) => this.request({
            path: `/classes/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name DeleteClass
         * @summary Delete Class
         * @request DELETE:/classes/{id}
         * @secure
         */
        deleteClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get class. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags global_classes
         * @name GetClass
         * @summary Get Class
         * @request GET:/classes/{id}
         * @secure
         */
        getClass: (id, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a class. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags global_classes
         * @name UpdateClass
         * @summary Update Class
         * @request PUT:/classes/{id}
         * @secure
         */
        updateClass: (id, data, params = {}) => this.request({
            path: `/classes/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    clusters = {
        /**
         * @description Get compute clusters information.
         *
         * @tags monitor
         * @name GetComputeClusters
         * @summary Get Compute Clusters
         * @request GET:/clusters
         * @secure
         */
        getComputeClusters: (params = {}) => this.request({
            path: `/clusters`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    customAnnotationSources = {
        /**
         * @description List custom annotation sources. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSources
         * @summary List Custom Annotation Sources
         * @request GET:/custom-annotation-sources
         * @secure
         */
        listCustomAnnotationSources: (query, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name CreateCustomAnnotationSource
         * @summary Create Custom Annotation Source
         * @request POST:/custom-annotation-sources
         * @secure
         */
        createCustomAnnotationSource: (data, params = {}) => this.request({
            path: `/custom-annotation-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source by name. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSourceByName
         * @summary Get Custom Annotation Source By Name
         * @request GET:/custom-annotation-sources/name/{name}
         * @secure
         */
        getCustomAnnotationSourceByName: (name, params = {}) => this.request({
            path: `/custom-annotation-sources/name/${name}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name DeleteCustomAnnotationSource
         * @summary Delete Custom Annotation Source
         * @request DELETE:/custom-annotation-sources/{id}
         * @secure
         */
        deleteCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name GetCustomAnnotationSource
         * @summary Get Custom Annotation Source
         * @request GET:/custom-annotation-sources/{id}
         * @secure
         */
        getCustomAnnotationSource: (id, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a custom annotation source. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name UpdateCustomAnnotationSource
         * @summary Update Custom Annotation Source
         * @request PUT:/custom-annotation-sources/{id}
         * @secure
         */
        updateCustomAnnotationSource: (id, data, params = {}) => this.request({
            path: `/custom-annotation-sources/${id}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List custom annotation source fields. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags custom_annotation_sources
         * @name ListCustomAnnotationSourceFields
         * @summary List Custom Annotation Source Fields
         * @request GET:/custom-annotation_sources/fields
         * @secure
         */
        listCustomAnnotationSourceFields: (params = {}) => this.request({
            path: `/custom-annotation_sources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    daemons = {
        /**
         * @description List daemons. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags daemons
         * @name ListDaemons
         * @summary List Daemons
         * @request GET:/daemons
         * @secure
         */
        listDaemons: (params = {}) => this.request({
            path: `/daemons`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datapools = {
        /**
         * @description List datapools. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapools
         * @summary List Datapools
         * @request GET:/datapools
         * @secure
         */
        listDatapools: (query, params = {}) => this.request({
            path: `/datapools`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a datapool in a project. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name CreateDatapool
         * @summary Create Datapool
         * @request POST:/datapools
         * @secure
         */
        createDatapool: (data, params = {}) => this.request({
            path: `/datapools`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolFields
         * @summary List Datapool Fields
         * @request GET:/datapools/fields
         * @secure
         */
        listDatapoolFields: (params = {}) => this.request({
            path: `/datapools/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete datapool. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datapools
         * @name DeleteDatapool
         * @summary Delete Datapool
         * @request DELETE:/datapools/{datapool_id}
         * @secure
         */
        deleteDatapool: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapool
         * @summary Get Datapool
         * @request GET:/datapools/{datapool_id}
         * @secure
         */
        getDatapool: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this datapool. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name GetDatapoolClasses
         * @summary Get Datapool Classes
         * @request GET:/datapools/{datapool_id}/classes
         * @secure
         */
        getDatapoolClasses: (datapoolId, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update classes of this datapool. **Accepted permissions:** * DATA_UPLOAD * PROJECT_CREATION
         *
         * @tags datapools
         * @name UpdateDatapoolClasses
         * @summary Update Datapool Classes
         * @request PUT:/datapools/{datapool_id}/classes
         * @secure
         */
        updateDatapoolClasses: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/classes`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateDataset
         * @summary Create Dataset
         * @request POST:/datapools/{datapool_id}/datasets
         * @secure
         */
        createDataset: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a dataset split. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name CreateSplit
         * @summary Create Split
         * @request POST:/datapools/{datapool_id}/datasets/splits
         * @secure
         */
        createSplit: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/datasets/splits`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources for filtered samples. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListFilteredDatapoolSources
         * @summary List Filtered Datapool Sources
         * @request POST:/datapools/{datapool_id}/filtered-sources
         * @secure
         */
        listFilteredDatapoolSources: (datapoolId, data, params = {}) => this.request({
            path: `/datapools/${datapoolId}/filtered-sources`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List datapool sources. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION
         *
         * @tags datapools
         * @name ListDatapoolSources
         * @summary List Datapool Sources
         * @request GET:/datapools/{datapool_id}/sources
         * @secure
         */
        listDatapoolSources: (datapoolId, query, params = {}) => this.request({
            path: `/datapools/${datapoolId}/sources`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
    };
    datasets = {
        /**
         * @description List datasets. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasets
         * @summary List Datasets
         * @request GET:/datasets
         * @secure
         */
        listDatasets: (query, params = {}) => this.request({
            path: `/datasets`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset fields. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetFields
         * @summary List Dataset Fields
         * @request GET:/datasets/fields
         * @secure
         */
        listDatasetFields: (params = {}) => this.request({
            path: `/datasets/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name DeleteDataset
         * @summary Delete Dataset
         * @request DELETE:/datasets/{dataset_id}
         * @secure
         */
        deleteDataset: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDataset
         * @summary Get Dataset
         * @request GET:/datasets/{dataset_id}
         * @secure
         */
        getDataset: (datasetId, query, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a dataset. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags datasets
         * @name UpdateDataset
         * @summary Update Dataset
         * @request PATCH:/datasets/{dataset_id}
         * @secure
         */
        updateDataset: (datasetId, data, params = {}) => this.request({
            path: `/datasets/${datasetId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get classes of this dataset. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name GetDatasetClasses
         * @summary Get Dataset Classes
         * @request GET:/datasets/{dataset_id}/classes
         * @secure
         */
        getDatasetClasses: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/classes`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List dataset sources. **Accepted permissions:** * DATA_LABELING * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION
         *
         * @tags datasets
         * @name ListDatasetSources
         * @summary List Dataset Sources
         * @request GET:/datasets/{dataset_id}/sources
         * @secure
         */
        listDatasetSources: (datasetId, params = {}) => this.request({
            path: `/datasets/${datasetId}/sources`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    deployments = {
        /**
         * @description List all deployments. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeployments
         * @summary List Deployments
         * @request GET:/deployments
         * @secure
         */
        listDeployments: (query, params = {}) => this.request({
            path: `/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeployment
         * @summary Create Deployment
         * @request POST:/deployments
         * @secure
         */
        createDeployment: (data, params = {}) => this.request({
            path: `/deployments`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List deployment fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentFields
         * @summary List Deployment Fields
         * @request GET:/deployments/fields
         * @secure
         */
        listDeploymentFields: (params = {}) => this.request({
            path: `/deployments/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a Deployment placeholder. This Deployment placeholder can have dependencies on resources which do not have valid values yet. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name CreateDeploymentPlaceholder
         * @summary Create Deployment Placeholder
         * @request POST:/deployments/placeholder
         * @secure
         */
        createDeploymentPlaceholder: (data, params = {}) => this.request({
            path: `/deployments/placeholder`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name RegisterExternalDeployment
         * @summary Register External Deployment
         * @request POST:/deployments/register
         * @secure
         */
        registerExternalDeployment: (data, params = {}) => this.request({
            path: `/deployments/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name DeleteDeployment
         * @summary Delete Deployment
         * @request DELETE:/deployments/{deployment_id}
         * @secure
         */
        deleteDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeployment
         * @summary Get Deployment
         * @request GET:/deployments/{deployment_id}
         * @secure
         */
        getDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeployment
         * @summary Update Deployment
         * @request PATCH:/deployments/{deployment_id}
         * @secure
         */
        updateDeployment: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment api endpoints info. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentApiEndpoints
         * @summary Get Deployment Api Endpoints
         * @request GET:/deployments/{deployment_id}/api-endpoints
         * @secure
         */
        getDeploymentApiEndpoints: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a deployment. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentArtifacts
         * @summary Get Deployment Artifacts
         * @request GET:/deployments/{deployment_id}/artifacts
         * @secure
         */
        getDeploymentArtifacts: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get deployment dependencies. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentDependencies
         * @summary Get Deployment Dependencies
         * @request GET:/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependencies: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log heartbeat for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogHeartbeat
         * @summary Log Heartbeat
         * @request PATCH:/deployments/{deployment_id}/heartbeat
         * @secure
         */
        logHeartbeat: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/heartbeat`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Get logs of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name GetDeploymentLogs
         * @summary Get Deployment Logs
         * @request GET:/deployments/{deployment_id}/logs
         * @secure
         */
        getDeploymentLogs: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name SaveDeploymentLogs
         * @summary Save Deployment Logs
         * @request POST:/deployments/{deployment_id}/logs
         * @secure
         */
        saveDeploymentLogs: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/logs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessages
         * @summary List Deployment Messages
         * @request GET:/deployments/{deployment_id}/messages
         * @secure
         */
        listDeploymentMessages: (deploymentId, query, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name LogDeploymentMessage
         * @summary Log Deployment Message
         * @request POST:/deployments/{deployment_id}/messages
         * @secure
         */
        logDeploymentMessage: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List deployment message fields. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name ListDeploymentMessageFields
         * @summary List Deployment Message Fields
         * @request GET:/deployments/{deployment_id}/messages/fields
         * @secure
         */
        listDeploymentMessageFields: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a deployment. **Accepted permissions:** * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StartDeployment
         * @summary Start Deployment
         * @request POST:/deployments/{deployment_id}/start
         * @secure
         */
        startDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/start`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name UpdateDeploymentStatus
         * @summary Update Deployment Status
         * @request PATCH:/deployments/{deployment_id}/status
         * @secure
         */
        updateDeploymentStatus: (deploymentId, data, params = {}) => this.request({
            path: `/deployments/${deploymentId}/status`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a deployment. **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags deployments
         * @name StopDeployment
         * @summary Stop Deployment
         * @request POST:/deployments/{deployment_id}/stop
         * @secure
         */
        stopDeployment: (deploymentId, params = {}) => this.request({
            path: `/deployments/${deploymentId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    errors = {
        /**
         * @description List application errors.
         *
         * @tags monitor
         * @name ListErrors
         * @summary List Errors
         * @request GET:/errors
         * @secure
         */
        listErrors: (params = {}) => this.request({
            path: `/errors`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    exampleStreams = {
        /**
         * @description List all example streams. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name ListExampleStreams
         * @summary List Example Streams
         * @request GET:/example-streams
         * @secure
         */
        listExampleStreams: (query, params = {}) => this.request({
            path: `/example-streams`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create example stream. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name CreateExampleStream
         * @summary Create Example Stream
         * @request POST:/example-streams
         * @secure
         */
        createExampleStream: (data, params = {}) => this.request({
            path: `/example-streams`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete example stream. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name DeleteExampleStream
         * @summary Delete Example Stream
         * @request DELETE:/example-streams/{example_stream_id}
         * @secure
         */
        deleteExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get example stream. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags example_streams
         * @name GetExampleStream
         * @summary Get Example Stream
         * @request GET:/example-streams/{example_stream_id}
         * @secure
         */
        getExampleStream: (exampleStreamId, params = {}) => this.request({
            path: `/example-streams/${exampleStreamId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    inferenceBundles = {
        /**
         * @description **Accepted permissions:** * EDGE
         *
         * @tags inference-bundles
         * @name ListInferenceBundles
         * @summary List Inference Bundles
         * @request GET:/inference-bundles
         * @secure
         */
        listInferenceBundles: (query, params = {}) => this.request({
            path: `/inference-bundles`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List job fields. **Accepted permissions:** * EDGE
         *
         * @tags inference-bundles
         * @name ListInferenceBundleFields
         * @summary List Inference Bundle Fields
         * @request GET:/inference-bundles/fields
         * @secure
         */
        listInferenceBundleFields: (params = {}) => this.request({
            path: `/inference-bundles/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * EDGE
         *
         * @tags inference-bundles
         * @name GetInferenceBundle
         * @summary Get Inference Bundle
         * @request GET:/inference-bundles/{inference_bundle_id}
         * @secure
         */
        getInferenceBundle: (inferenceBundleId, params = {}) => this.request({
            path: `/inference-bundles/${inferenceBundleId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    jobs = {
        /**
         * @description List all jobs. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobs
         * @summary List Jobs
         * @request GET:/jobs
         * @secure
         */
        listJobs: (query, params = {}) => this.request({
            path: `/jobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a job. All parameters (parameters, models, datasets) are linked with the `job_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name StartJob
         * @summary Start Job
         * @request POST:/jobs
         * @secure
         */
        startJob: (data, params = {}) => this.request({
            path: `/jobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List job fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobFields
         * @summary List Job Fields
         * @request GET:/jobs/fields
         * @secure
         */
        listJobFields: (params = {}) => this.request({
            path: `/jobs/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external job. Alternative for start_job, but without actually starting the job. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags jobs
         * @name RegisterExternalJob
         * @summary Register External Job
         * @request POST:/jobs/register
         * @secure
         */
        registerExternalJob: (data, params = {}) => this.request({
            path: `/jobs/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a job. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags jobs
         * @name DeleteJob
         * @summary Delete Job
         * @request DELETE:/jobs/{job_id}
         * @secure
         */
        deleteJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJob
         * @summary Get Job
         * @request GET:/jobs/{job_id}
         * @secure
         */
        getJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job api endpoints info. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobApiEndpoints
         * @summary Get Job Api Endpoints
         * @request GET:/jobs/{job_id}/api-endpoints
         * @secure
         */
        getJobApiEndpoints: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/api-endpoints`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get artifacts of a job. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobArtifacts
         * @summary Get Job Artifacts
         * @request GET:/jobs/{job_id}/artifacts
         * @secure
         */
        getJobArtifacts: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/artifacts`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobCreator
         * @summary Get Job Creator
         * @request GET:/jobs/{job_id}/creator
         * @secure
         */
        getJobCreator: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/creator`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get job dependencies. **Accepted permissions:** * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION
         *
         * @tags jobs
         * @name GetJobDependencies
         * @summary Get Job Dependencies
         * @request GET:/jobs/{job_id}/dependencies
         * @secure
         */
        getJobDependencies: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get logs of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name GetJobLogs
         * @summary Get Job Logs
         * @request GET:/jobs/{job_id}/logs
         * @secure
         */
        getJobLogs: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description Save logs to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name SaveJobLogs
         * @summary Save Job Logs
         * @request PUT:/jobs/{job_id}/logs
         * @secure
         */
        saveJobLogs: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/logs`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Get latest status messages of a job. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessages
         * @summary List Job Messages
         * @request GET:/jobs/{job_id}/messages
         * @secure
         */
        listJobMessages: (jobId, query, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Log a status message for a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name LogJobMessage
         * @summary Log Job Message
         * @request POST:/jobs/{job_id}/messages
         * @secure
         */
        logJobMessage: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/messages`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List job message fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name ListJobMessageFields
         * @summary List Job Message Fields
         * @request GET:/jobs/{job_id}/messages/fields
         * @secure
         */
        listJobMessageFields: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/messages/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobMetadata
         * @summary Update Job Metadata
         * @request PUT:/jobs/{job_id}/metadata
         * @secure
         */
        updateJobMetadata: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status to job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name UpdateJobStatus
         * @summary Update Job Status
         * @request POST:/jobs/{job_id}/status
         * @secure
         */
        updateJobStatus: (jobId, data, params = {}) => this.request({
            path: `/jobs/${jobId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a job. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags jobs
         * @name StopJob
         * @summary Stop Job
         * @request POST:/jobs/{job_id}/stop
         * @secure
         */
        stopJob: (jobId, params = {}) => this.request({
            path: `/jobs/${jobId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    logs = {
        /**
         * @description Prepare server logs.
         *
         * @tags monitor
         * @name PrepareLogs
         * @summary Prepare Logs
         * @request POST:/logs
         * @secure
         */
        prepareLogs: (query, params = {}) => this.request({
            path: `/logs`,
            method: "POST",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Download server logs.
         *
         * @tags monitor
         * @name DownloadLogs
         * @summary Download Logs
         * @request GET:/logs/{zip_filename}
         * @secure
         */
        downloadLogs: (zipFilename, params = {}) => this.request({
            path: `/logs/${zipFilename}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    platformConnection = {
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name DeletePlatformConnection
         * @summary Delete Platform Connection
         * @request DELETE:/platform-connection
         * @secure
         */
        deletePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetPlatformConnection
         * @summary Get Platform Connection
         * @request GET:/platform-connection
         * @secure
         */
        getPlatformConnection: (params = {}) => this.request({
            path: `/platform-connection`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name CreatePlatformConnection
         * @summary Create Platform Connection
         * @request POST:/platform-connection
         * @secure
         */
        createPlatformConnection: (data, params = {}) => this.request({
            path: `/platform-connection`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListAlgorithmsFromConnection
         * @summary List Algorithms From Connection
         * @request GET:/platform-connection/algorithms
         * @secure
         */
        listAlgorithmsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/algorithms`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListDeploymentsFromConnection
         * @summary List Deployments From Connection
         * @request GET:/platform-connection/deployments
         * @secure
         */
        listDeploymentsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/deployments`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetDeploymentDependenciesFromConnection
         * @summary Get Deployment Dependencies From Connection
         * @request GET:/platform-connection/deployments/{deployment_id}/dependencies
         * @secure
         */
        getDeploymentDependenciesFromConnection: (deploymentId, params = {}) => this.request({
            path: `/platform-connection/deployments/${deploymentId}/dependencies`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all projects from the latest hub connection that are compatible with the current project. Compatible projects are projects with the same algorithm type. If no connection id is provided, it defaults to the latest one that was set up. **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ListProjectsFromConnection
         * @summary List Projects From Connection
         * @request GET:/platform-connection/projects
         * @secure
         */
        listProjectsFromConnection: (query, params = {}) => this.request({
            path: `/platform-connection/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD EDGE * DATA_UPLOAD MODEL_CREATION * EDGE SYSTEM_MANAGEMENT * INFERENCE * MODEL_CREATION SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name GetParametersResourceDataFromConnection
         * @summary Get Parameters Resource Data From Connection
         * @request GET:/platform-connection/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceDataFromConnection: (resourceId, params = {}) => this.request({
            path: `/platform-connection/resources/parameters/${resourceId}/data`,
            method: "GET",
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidatePlatformConnection
         * @summary Validate Platform Connection
         * @request GET:/platform-connection/validate
         * @secure
         */
        validatePlatformConnection: (params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags platform_connection
         * @name ValidateCredentials
         * @summary Validate Credentials
         * @request POST:/platform-connection/validate
         * @secure
         */
        validateCredentials: (data, params = {}) => this.request({
            path: `/platform-connection/validate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    projects = {
        /**
         * @description List all projects. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjects
         * @summary List Projects
         * @request GET:/projects
         * @secure
         */
        listProjects: (query, params = {}) => this.request({
            path: `/projects`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name CreateProject
         * @summary Create Project
         * @request POST:/projects
         * @secure
         */
        createProject: (data, params = {}) => this.request({
            path: `/projects`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List project fields. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectFields
         * @summary List Project Fields
         * @request GET:/projects/fields
         * @secure
         */
        listProjectFields: (params = {}) => this.request({
            path: `/projects/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List all project metadata. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name ListProjectMetadata
         * @summary List Project Metadata
         * @request GET:/projects/metadata
         * @secure
         */
        listProjectMetadata: (params = {}) => this.request({
            path: `/projects/metadata`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project by its name. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectByName
         * @summary Get Project By Name
         * @request GET:/projects/name/{project_name}
         * @secure
         */
        getProjectByName: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Check project name's existence. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name IsProjectNameAvailable
         * @summary Is Project Name Available
         * @request GET:/projects/name/{project_name}/availability
         * @secure
         */
        isProjectNameAvailable: (projectName, params = {}) => this.request({
            path: `/projects/name/${projectName}/availability`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a project. **Accepted permissions:** * INFERENCE MODEL_CREATION PROJECT_CREATION * MODEL_CREATION PROJECT_CREATION SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name DeleteProject
         * @summary Delete Project
         * @request DELETE:/projects/{project_id}
         * @secure
         */
        deleteProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a project. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProject
         * @summary Get Project
         * @request GET:/projects/{project_id}
         * @secure
         */
        getProject: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProject
         * @summary Update Project
         * @request PATCH:/projects/{project_id}
         * @secure
         */
        updateProject: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a default algorithm in project. **Accepted permissions:** * PROJECT_CREATION
         *
         * @tags projects
         * @name UpdateProjectDefaultAlgorithm
         * @summary Update Project Default Algorithm
         * @request PATCH:/projects/{project_id}/algorithm
         * @secure
         */
        updateProjectDefaultAlgorithm: (projectId, data, params = {}) => this.request({
            path: `/projects/${projectId}/algorithm`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get default project example definitions. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetDefaultProjectExampleDefinitions
         * @summary Get Default Project Example Definitions
         * @request GET:/projects/{project_id}/example-definitions
         * @secure
         */
        getDefaultProjectExampleDefinitions: (projectId, params = {}) => this.request({
            path: `/projects/${projectId}/example-definitions`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get project thumbnail. Supports authorization via ?token. **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags projects
         * @name GetProjectThumbnail
         * @summary Get Project Thumbnail
         * @request GET:/projects/{project_id}/thumbnail
         * @secure
         */
        getProjectThumbnail: (projectId, query, params = {}) => this.request({
            path: `/projects/${projectId}/thumbnail`,
            method: "GET",
            query: query,
            secure: true,
            format: "blob",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    resources = {
        /**
         * @description List resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResources
         * @summary List Resources
         * @request GET:/resources/
         * @secure
         */
        listResources: (query, params = {}) => this.request({
            path: `/resources/`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List blob resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListBlobResources
         * @summary List Blob Resources
         * @request GET:/resources/blobs
         * @secure
         */
        listBlobResources: (query, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create generic blob resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateBlobResource
         * @summary Create Blob Resource
         * @request POST:/resources/blobs
         * @secure
         */
        createBlobResource: (data, params = {}) => this.request({
            path: `/resources/blobs`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceInfo
         * @summary Get Blob Resource Info
         * @request GET:/resources/blobs/{resource_id}
         * @secure
         */
        getBlobResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override blob resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideBlobResourceMetadata
         * @summary Override Blob Resource Metadata
         * @request PUT:/resources/blobs/{resource_id}
         * @secure
         */
        overrideBlobResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get blob resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetBlobResourceData
         * @summary Get Blob Resource Data
         * @request GET:/resources/blobs/{resource_id}/data
         * @secure
         */
        getBlobResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put blob resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutBlobResourceData
         * @summary Put Blob Resource Data
         * @request PUT:/resources/blobs/{resource_id}/data
         * @secure
         */
        putBlobResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/blobs/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List resource fields. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListResourceFields
         * @summary List Resource Fields
         * @request GET:/resources/fields
         * @secure
         */
        listResourceFields: (params = {}) => this.request({
            path: `/resources/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List model resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListModelResources
         * @summary List Model Resources
         * @request GET:/resources/models
         * @secure
         */
        listModelResources: (query, params = {}) => this.request({
            path: `/resources/models`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create model resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateModelResource
         * @summary Create Model Resource
         * @request POST:/resources/models
         * @secure
         */
        createModelResource: (data, params = {}) => this.request({
            path: `/resources/models`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceInfo
         * @summary Get Model Resource Info
         * @request GET:/resources/models/{resource_id}
         * @secure
         */
        getModelResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override models resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideModelResourceMetadata
         * @summary Override Model Resource Metadata
         * @request PUT:/resources/models/{resource_id}
         * @secure
         */
        overrideModelResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get model resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetModelResourceData
         * @summary Get Model Resource Data
         * @request GET:/resources/models/{resource_id}/data
         * @secure
         */
        getModelResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put model resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutModelResourceData
         * @summary Put Model Resource Data
         * @request PUT:/resources/models/{resource_id}/data
         * @secure
         */
        putModelResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/models/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description List parameters resources. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name ListParametersResources
         * @summary List Parameters Resources
         * @request GET:/resources/parameters
         * @secure
         */
        listParametersResources: (query, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a parameters resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResource
         * @summary Create Parameters Resource
         * @request POST:/resources/parameters
         * @secure
         */
        createParametersResource: (data, params = {}) => this.request({
            path: `/resources/parameters`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.FormData,
            format: "json",
            ...params,
        }),
        /**
         * @description Create parameters resource and upload data via returned upload url. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name CreateParametersResourceWithUploadUrl
         * @summary Create Parameters Resource With Upload Url
         * @request POST:/resources/parameters/metadata
         * @secure
         */
        createParametersResourceWithUploadUrl: (data, params = {}) => this.request({
            path: `/resources/parameters/metadata`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource info. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceInfo
         * @summary Get Parameters Resource Info
         * @request GET:/resources/parameters/{resource_id}
         * @secure
         */
        getParametersResourceInfo: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Override parameters resource metadata. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name OverrideParametersResourceMetadata
         * @summary Override Parameters Resource Metadata
         * @request PUT:/resources/parameters/{resource_id}
         * @secure
         */
        overrideParametersResourceMetadata: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource data. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceData
         * @summary Get Parameters Resource Data
         * @request GET:/resources/parameters/{resource_id}/data
         * @secure
         */
        getParametersResourceData: (resourceId, query, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "GET",
            query: query,
            secure: true,
            format: "arraybuffer",
            ...params,
        }),
        /**
         * @description Put parameters resource data. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name PutParametersResourceData
         * @summary Put Parameters Resource Data
         * @request PUT:/resources/parameters/{resource_id}/data
         * @secure
         */
        putParametersResourceData: (resourceId, data, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/data`,
            method: "PUT",
            body: data,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get parameters resource definition. **Accepted permissions:** * EDGE * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name GetParametersResourceDefinition
         * @summary Get Parameters Resource Definition
         * @request GET:/resources/parameters/{resource_id}/definition
         * @secure
         */
        getParametersResourceDefinition: (resourceId, params = {}) => this.request({
            path: `/resources/parameters/${resourceId}/definition`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete resource. **Accepted permissions:** * INFERENCE * MODEL_CREATION
         *
         * @tags resources
         * @name DeleteResource
         * @summary Delete Resource
         * @request DELETE:/resources/{resource_id}
         * @secure
         */
        deleteResource: (resourceId, params = {}) => this.request({
            path: `/resources/${resourceId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    schemas = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * EDGE * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags schemas
         * @name GetDatapoolDefinition
         * @summary Get Datapool Definition
         * @request GET:/schemas/datapool/{definition_id}
         * @secure
         */
        getDatapoolDefinition: (definitionId, params = {}) => this.request({
            path: `/schemas/datapool/${definitionId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    sse = {
        /**
         * No description
         *
         * @tags sse
         * @name GetEvents
         * @summary Get Events
         * @request GET:/sse
         * @secure
         */
        getEvents: (query, params = {}) => this.request({
            path: `/sse`,
            method: "GET",
            query: query,
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description Get application version.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    workflows = {
        /**
         * @description List all workflows. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflows
         * @summary List Workflows
         * @request GET:/workflows
         * @secure
         */
        listWorkflows: (query, params = {}) => this.request({
            path: `/workflows`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Start a workflow. All parameters (parameters, models, datasets) are linked with the `workflow_id`. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name StartWorkflow
         * @summary Start Workflow
         * @request POST:/workflows
         * @secure
         */
        startWorkflow: (data, params = {}) => this.request({
            path: `/workflows`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List workflow fields. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name ListWorkflowFields
         * @summary List Workflow Fields
         * @request GET:/workflows/fields
         * @secure
         */
        listWorkflowFields: (params = {}) => this.request({
            path: `/workflows/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Register an external workflow. Alternative for start_workflow, but without actually starting the workflow. **Accepted permissions:** * INFERENCE SYSTEM_MANAGEMENT * MODEL_CREATION
         *
         * @tags workflows
         * @name RegisterExternalWorkflow
         * @summary Register External Workflow
         * @request POST:/workflows/register
         * @secure
         */
        registerExternalWorkflow: (data, params = {}) => this.request({
            path: `/workflows/register`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a workflow. **Accepted permissions:** * MODEL_CREATION
         *
         * @tags workflows
         * @name DeleteWorkflow
         * @summary Delete Workflow
         * @request DELETE:/workflows/{workflow_id}
         * @secure
         */
        deleteWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a workflow. **Accepted permissions:** * INFERENCE * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name GetWorkflow
         * @summary Get Workflow
         * @request GET:/workflows/{workflow_id}
         * @secure
         */
        getWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the metadata of a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowMetadata
         * @summary Update Workflow Metadata
         * @request PUT:/workflows/{workflow_id}/metadata
         * @secure
         */
        updateWorkflowMetadata: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/metadata`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Update status of workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name UpdateWorkflowStatus
         * @summary Update Workflow Status
         * @request POST:/workflows/{workflow_id}/status
         * @secure
         */
        updateWorkflowStatus: (workflowId, data, params = {}) => this.request({
            path: `/workflows/${workflowId}/status`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Stop a workflow. **Accepted permissions:** * MODEL_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags workflows
         * @name StopWorkflow
         * @summary Stop Workflow
         * @request POST:/workflows/{workflow_id}/stop
         * @secure
         */
        stopWorkflow: (workflowId, params = {}) => this.request({
            path: `/workflows/${workflowId}/stop`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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